import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Panel, COLORS, ChartTooltipStyle } from "./ui";

const GRAN = [{ id: "day", label: "יום" }, { id: "week", label: "שבוע" }, { id: "month", label: "חודש" }];

const GranToggle = ({ value, onChange }) => (
  <div className="inline-flex bg-gray-100 rounded-lg p-0.5 text-[11px] font-bold flex-shrink-0">
    {GRAN.map((g) => (
      <button
        key={g.id}
        onClick={() => onChange(g.id)}
        className={`px-2 py-1 rounded-md transition ${value === g.id ? "bg-white shadow text-indigo-700" : "text-gray-500 hover:text-gray-700"}`}
      >
        {g.label}
      </button>
    ))}
  </div>
);

const LABELS = { students: "תלמידים חדשים", teachers: "מורים חדשים", total: "סה״כ חדשים" };

const UsersGrowthChart = ({ data, granularity, onGranularityChange, loading, error, onRetry }) => (
  <Panel
    eyebrow="הרשמות"
    title="מגמת הרשמות"
    subtitle="תלמידים ומורים חדשים לאורך זמן"
    accent="sky"
    action={<GranToggle value={granularity} onChange={onGranularityChange} />}
    loading={loading}
    error={error}
    onRetry={onRetry}
    empty={!loading && !error && (!data || data.length === 0)}
  >
    <div className="h-56 sm:h-64">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <CartesianGrid stroke={COLORS.grid} vertical={false} />
          <XAxis dataKey="period" tick={{ fontSize: 12, fill: "#6b7280" }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 12, fill: "#6b7280" }} axisLine={false} tickLine={false} />
          <Tooltip formatter={(val, name) => [val, LABELS[name] || name]} contentStyle={ChartTooltipStyle} />
          <Legend wrapperStyle={{ fontSize: 11 }} formatter={(v) => LABELS[v] || v} />
          <Line type="monotone" dataKey="students" stroke={COLORS.sky} strokeWidth={2.5} dot={{ r: 3 }} />
          <Line type="monotone" dataKey="teachers" stroke={COLORS.emerald} strokeWidth={2.5} dot={{ r: 3 }} />
          <Line type="monotone" dataKey="total" stroke={COLORS.indigo} strokeWidth={2} strokeDasharray="4 3" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </Panel>
);

export default UsersGrowthChart;
